import React, { useState, useEffect } from "react";
import { Box, Card, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import KeyRoundedIcon from "@mui/icons-material/KeyRounded";
import { useDispatch, useSelector } from "react-redux";

import CustomAvatar from "../CustomAvatar";
import {
  getSettingState,
  setCustomModal,
} from "../../../redux/features/settingSlice";
import CustomButton from "../CustomButton";
import useFollow from "../../../hooks/UseFollow";
import RightLeftChecker from "../../../utils/RightLeftChecker";

const UserCard = ({ rowData, firstIndex }) => {
  const navigate = useNavigate();
  const { userData, modalType } = useSelector(getSettingState);
  const dispatch = useDispatch();
  const [followBtn, setFollowBtn] = useState(false);
  const [handleFollowBtn] = useFollow(rowData, followBtn, setFollowBtn);

  useEffect(() => {
    rowData && setFollowBtn(rowData.followed);
  }, [rowData]);

  const handleGoToUser = () => {
    dispatch(setCustomModal(false));
    navigate(`/profile/${rowData.username}`);
  };

  return (
    <Card
      sx={{
        width: "100%",
        padding: `16px`,
        border: `2px solid`,
        borderColor: "black.main",
        borderRadius: `16px`,
        maxHeight: "80px",
        boxShadow: `0px 0px 0px`,
        marginBottom: `16px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          overflow: "hidden",
          width: "100%",
        }}
      >
        <Box onClick={handleGoToUser} sx={{ mr: "8px" }}>
          <CustomAvatar src={rowData.avatar} size={48} alt={rowData.nickname} />
        </Box>

        <Box
          sx={{
            cursor: "pointer",
            width: "100%",
            mr: "8px",
          }}
          onClick={handleGoToUser}
        >
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                noWrap
                sx={{
                  fontSize: "19px",
                  fontWeight: "600",
                  lineHeight: "28px",
                  maxWidth: "63%",
                  mt: "6px",
                  direction: RightLeftChecker(rowData.nickname) ? "rtl" : "ltr",
                }}
              >
                {rowData.nickname}
              </Typography>
              {firstIndex === 0 && modalType === "Participants" && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    ml: "6px",
                    mb: "7px",
                    backgroundColor: "secondary.main",
                    border: "0.78px solid",
                    borderColor: "black.main",
                    borderRadius: "50%",
                    width: "16px",
                    height: "16px",
                    color: "#ffffff",
                  }}
                >
                  <KeyRoundedIcon sx={{ fontSize: "11px" }} />
                </Box>
              )}
            </Box>
          </Box>

          <Typography
            noWrap
            sx={{
              fontSize: "12px",
              fontWeight: "400",
              lineHeight: "16px",
              color: "mute.main",
              maxWidth: "68%",
              direction: RightLeftChecker(rowData.bio) ? "rtl" : "ltr",
            }}
          >
            {rowData.bio}
          </Typography>
        </Box>
      </Box>

      <CustomButton
        title={followBtn ? "Followed" : "Follow"}
        onClick={() => handleFollowBtn()}
        disabled={userData === rowData.id}
        fSize='12px'
        width='61px'
        height='32px'
        bShadow='2px'
        color={followBtn ? "white.main" : "black.main"}
        bgColor={followBtn ? "black.main" : "primary.main"}
      />
    </Card>
  );
};

export default UserCard;
